import { render, staticRenderFns } from "./FreshnessChart.vue?vue&type=template&id=0ca39cae"
import script from "./FreshnessChart.vue?vue&type=script&lang=js"
export * from "./FreshnessChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports